module.exports = __webpack_public_path__ + "img/playon-5.25878201.jpg";